import { createAction, props } from '@ngrx/store';
import { Rider, PagedRiders, RiderForm } from '../../models/riders.model';

export const loadAllRiders = createAction(
  '[Rider] Load All Riders',
  props<{ page: number, limit: number, query?: string }>()
);

export const loadAllRidersSuccess = createAction(
  '[Rider] Load All Riders Success',
  props<{ riders: PagedRiders }>()
);

export const loadAllRidersFailure = createAction(
  '[Rider] Load All Riders Failure',
  props<{ error: any }>()
);

export const updatedRider = createAction(
  '[Rider] Update Rider',
  props<{ rider: Rider }>()
);

export const loadRidersLocations = createAction(
  '[Rider] Load Riders Locations'
);

export const loadRidersLocationsSuccess = createAction(
  '[Rider] Load Riders Locations Success',
  props<{ ridersLocations: any }>()
);

export const loadRidersLocationsFailure = createAction(
  '[Rider] Load Riders Locations Failure',
  props<{ error: any }>()
);

export const searchRiders = createAction(
  '[Rider] Search Riders',
  props<{ page: number, limit: number, query: string, vehicle_type?: number }>()
);

export const searchRidersSuccess = createAction(
  '[Rider] Search Riders Success',
  props<{ riders: PagedRiders }>()
);

export const searchRidersFailure = createAction(
  '[Rider] Search Riders Failure',
  props<{ error: any }>()
);

export const createRider = createAction(
    '[Rider] Create Rider',
);

export const createRiderSuccess = createAction(
    '[Rider] Create Rider Success',
    props<{ rider: Rider }>()
);

export const createRiderFailure = createAction(
    '[Rider] Create Rider Failure',
    props<{ error: any }>()
);

export const editRider = createAction(
    '[Rider] Edit Rider',
);

export const editRiderSuccess = createAction(
    '[Rider] Edit Rider Success',
    props<{ rider: Rider }>()
);

export const editRiderFailure = createAction(
    '[Rider] Edit Rider Failure',
    props<{ error: any }>()
);

export const deleteRider = createAction(
    '[Rider] Delete Rider',
    props<{ id: number }>()
);

export const deleteRiderSuccess = createAction(
    '[Rider] Delete Rider Success',
    props<{ id: number }>()
);

export const deleteRiderFailure = createAction(
    '[Rider] Delete Rider Failure',
    props<{ error: any }>()
);

export const loadRiderById = createAction(
    '[Rider] Load Rider By Id',
    props<{ id: number }>()
);

export const loadRiderByIdSuccess = createAction(
    '[Rider] Load Rider By Id Success',
    props<{ rider: Rider }>()
);

export const loadRiderByIdFailure = createAction(
    '[Rider] Load Rider By Id Failure',
    props<{ error: any }>()
);
 export const resetRider = createAction(
    '[Rider] Go Back Rider'
);
export const refreshRiderLocations = createAction(
  '[Riders] Refresh Rider Location',
  props<{ rider_id: number; latitude: number; longitude: number }>()
);

export const selectRider = createAction(
  '[Rider] Select Rider',
  props<{ rider_id: number }>()
);

export const selectRiderSuccess = createAction(
  '[Rider] Select Rider Success',
  props<{ rider: Rider }>()
);

export const selectRiderFailure = createAction(
  '[Rider] Select Rider Failure',
  props<{ error: any }>()
);

export const markRiderAsBusy = createAction(
  '[Riders] Mark Rider As Busy',
  props<{ rider_id: number }>()
);
